<style src="./CashRelief.scss" lang="scss"></style>
<template>
  <div class="cash-container">
    <h2 class="title">Preencha o formulário para realizar a sangria</h2>
    <form
      class="form"
      v-on:submit.prevent="AddCashRelief"
      v-if="haveUserSelected"
    >
      <div class="form-group">
        <label>Valor</label>
        <input
          type="number"
          class="form-control"
          v-model="amount"
          step="0.01"
          value="0.00"
          placeholder="0.00"
        />
      </div>
      <div class="form-group">
        <label>Descição</label>
        <input type="text" class="form-control" v-model="description" />
      </div>
      <button
        class="btn btn-block btn-primary compose-mail"
        href="mail_compose.html"
      >
        <i class="fa fa-save"></i>
        Enviar
      </button>
    </form>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  data: () => ({
    amount: '',
    description: '',
  }),

  computed: {
    haveUserSelected() {
      return !!this.$route.params.userId;
    },
  },

  methods: {
    async AddCashRelief() {
      try {
        const askedUserId = this.$route.params.userId;
        const payload = {
          description: this.description,
          amount: this.amount * 100,
          askedUserId,
        };
        await this.$store.dispatch('ACCOUNTING-CASH/AddCashRelief', payload);
        toast.success('Sangria realizada com sucesso!');
        this.amount = '';
        this.description = '';
      } catch (error) {
        toast.error('Não foi possível realizar sangria.');
      }
    },
  },
};
</script>